import { render, staticRenderFns } from "./Musafir_orders.vue?vue&type=template&id=f32770c0&"
import script from "./Musafir_orders.vue?vue&type=script&lang=js&"
export * from "./Musafir_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports